type CalculatorContext = {
  program?: string | null
  courseCategory?: string | null
  isReviewMode?: boolean
  isPreviewMode?: boolean
  // The student_experience_calculator flag; it gates only the WKAM quizzes Ready#7749 added.
  isRolloutEnabled?: boolean
}

const CALCULATOR_COURSE_CATEGORY = 'math'
const AVAILABLE_CALCULATOR_PROGRAMS = ['TSIA2', 'ACT', 'EACT']
const APPLIED_MATH_PROGRAMS = ['WKAM', 'WKAMES']

export const isCalculatorAvailable = ({
  program,
  courseCategory,
  isReviewMode = false,
  isPreviewMode = false,
  isRolloutEnabled = false,
}: CalculatorContext): boolean => {
  if (program === 'STAAR') return true
  if (isReviewMode) return false

  if (APPLIED_MATH_PROGRAMS.includes(program?.toUpperCase() ?? '')) return isRolloutEnabled && !isPreviewMode

  return (
    AVAILABLE_CALCULATOR_PROGRAMS.includes(program ?? '') &&
    courseCategory?.toLowerCase() === CALCULATOR_COURSE_CATEGORY
  )
}
